import { useQuery } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';

export const useBitwerxOfferings = () => {
  const query = useQuery({
    queryKey: queryKeys.offerings.bitwerx.lists(),
    queryFn: offeringsService.getBitwerxOfferings,
  });

  return {
    offerings: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useBitwerxOfferings;
